import { MEDICAL_CONDITIONS } from "@./cat-calculations";
import { snakeCaseToCamelCase } from "@utils/misc";
import { useTranslations } from "next-intl";

import { createEnumTranslations } from "./createEnumTranslations";

const medicalConditions = MEDICAL_CONDITIONS.map(({ value }) => value);

export const useCatMedicalConditions = () => {
  const tMedicalConditions = useTranslations("Cats.MedicalConditions");
  const tVocabulary = useTranslations("Shared.Vocabulary");
  const unknown = tVocabulary("unknown");

  return createEnumTranslations({
    values: medicalConditions,
    translate: (medicalCondition) => (
      tMedicalConditions(snakeCaseToCamelCase(medicalCondition))
    ),
    fallback: unknown,
  });
};
